import { Heart } from "lucide-react";

const ITEMS = [
  "Cada doação vira ração",
  "Cuidado veterinário 24h",
  "Vacinas em dia",
  "Resgate e muito amor",
  "Abrigo seguro e quentinho",
  "Segunda chance para patinhas",
];

function Track({ hidden }) {
  return (
    <div aria-hidden={hidden || undefined} className="flex w-max items-center gap-10 pr-10">
      {ITEMS.map((item) => (
        <span
          key={item}
          className="font-display flex items-center gap-10 whitespace-nowrap text-sm font-bold uppercase tracking-[0.18em]"
        >
          {item} <Heart className="h-4 w-4 fill-white/70 text-white/70" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div className="marquee-wrap overflow-hidden bg-[#FF6D47] py-3.5 text-white shadow-[0_10px_40px_rgba(255,109,71,0.25)]">
      <div className="flex w-max animate-marquee">
        <Track />
        <Track hidden />
      </div>
    </div>
  );
}
